export default "__VITE_ASSET__BrXnUmte__"